import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EltonDiscrepancies } from "@app/models/eltonsettlement/elton-discrepancies.model";
import { environment } from "@environments/environment";

@Injectable()
export class EltonSettlementService {

  private uri: string = `${environment.routes.apiEndpoint}/elton-settlement`;

  constructor(private http: HttpClient) { }

  getEltonDiscrepancies(dateFrom: Date | null = null, dateTo: Date | null = null, paymentReferenceId: string | null = null) {
    let filters = '';
    if (dateFrom != null) filters += `&dateFrom=${dateFrom.toISOString()}`;
    if (dateTo != null) filters += `&dateTo=${dateTo.toISOString()}`;
    if (paymentReferenceId != null) filters += `&providerReferenceId=${encodeURIComponent(paymentReferenceId)}`;
    return this.http.get<EltonDiscrepancies>(`${this.uri}/settlements/unverified?${filters}`);
  }

  acceptSaleManually(saleId: string, comment: string) {
    return this.http.post<void>(`${this.uri}/sales/${saleId}/accept-manually`, { comment });
  }
}
